import { useState } from 'react';
import { 
  
  Typography, 
  Grid, 
  Paper, 
  Button, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  TextField, 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel,
  Chip,
  Container
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Layout from '../components/layout/Calayout';

const StaffAllocation = () => {
  const [openAllocationDialog, setOpenAllocationDialog] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);


  const [staffData, ] = useState([
    {
      id: 1,
      name: 'John Doe',
      department: 'Audit',
      currentWorkload: 60,
      maxWorkload: 80,
      specialization: 'Financial Audit',
      status: 'Available'
    },
    {
      id: 2,
      name: 'Jane Smith',
      department: 'Tax',
      currentWorkload: 75,
      maxWorkload: 90,
      specialization: 'Corporate Tax',
      status: 'Busy'
    },
    {
      id: 3,
      name: 'Mike Johnson',
      department: 'Compliance',
      currentWorkload: 50,
      maxWorkload: 100,
      specialization: 'Regulatory Compliance',
      status: 'Available'
    }
  ]);

  const getWorkloadColor = (currentWorkload, maxWorkload) => {
    const percentage = (currentWorkload / maxWorkload) * 100;
    if (percentage < 50) return 'success';
    if (percentage < 80) return 'warning';
    return 'error';
  };

  const columns = [
    { 
      field: 'name', 
      headerName: 'Name', 
      flex: 1 
    },
    { 
      field: 'department', 
      headerName: 'Department', 
      flex: 1 
    },
    { 
      field: 'specialization', 
      headerName: 'Specialization', 
      flex: 1 
    },
    { 
      field: 'currentWorkload', 
      headerName: 'Workload', 
      flex: 1,
      renderCell: (params) => {
        const { currentWorkload, maxWorkload } = params.row;
        return (
          <Chip 
            label={`${currentWorkload}/${maxWorkload}`} 
            color={getWorkloadColor(currentWorkload, maxWorkload)}
            variant="outlined"
          />
        );
      }
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      flex: 1,
      renderCell: (params) => (
        <Chip 
          label={params.value} 
          color={params.value === 'Available' ? 'success' : 'error'}
          variant="outlined"
        />
      )
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            setSelectedStaff(params.row);
            setOpenAllocationDialog(true);
          }}
        >
          Allocate Task
        </Button>
      )
    }
  ];

  const handleCloseAllocationDialog = () => {
    setOpenAllocationDialog(false);
    setSelectedStaff(null);
  };

  const handleAllocateTask = () => {
    // Logic to allocate task to selected staff
   
    handleCloseAllocationDialog();
  };

  return (
    <Layout>
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom>
          Staff Allocation Management
        </Typography>

        <Paper sx={{ width: '100%', mb: 2 }}>
          <DataGrid
            rows={staffData}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            disableSelectionOnClick
            autoHeight
          />
        </Paper>

        <Dialog
          open={openAllocationDialog}
          onClose={handleCloseAllocationDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Allocate Task to {selectedStaff?.name}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel>Task Type</InputLabel>
                  <Select label="Task Type">
                    <MenuItem value="audit">Audit</MenuItem>
                    <MenuItem value="tax">Tax Preparation</MenuItem>
                    <MenuItem value="compliance">Compliance Review</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Task Description"
                  multiline
                  rows={4}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAllocationDialog} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleAllocateTask} color="primary" variant="contained">
              Allocate
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Layout>
  );
};

export default StaffAllocation;